import { cva } from 'class-variance-authority';

export const itemVariants = cva(
  [
    'group',
    'font-comp-accordion-label-font-family',
    'font-comp-accordion-label-font-weight',
    'text-font-comp-accordion-label-font-size',
    'font-comp-accordion-label-font-weight',
    'leading-font-comp-accordion-label-line-height',
    '[&[data-disabled]]:font-comp-accordion-label-font-family',
    '[&[data-disabled]]:font-comp-accordion-label-font-weight',
    '[&[data-disabled]]:text-font-comp-accordion-label-font-size',
    '[&[data-disabled]]:font-comp-accordion-label-font-weight',
    '[&[data-disabled]]:leading-font-comp-accordion-label-line-height',
    'overflow-hidden',
    'transition-colors',
    'duration-300',
  ],
  {
    variants: {
      grouped: {
        false: ['rounded-radius-comp-accordion-round'],
        true: [
          'first:rounded-t-radius-comp-accordion-round',
          'last:rounded-b-radius-comp-accordion-round',
        ],
      },
      fill: {
        filled: [
          // Background colors
          'bg-color-comp-accordion-filled-container-default',
          '[&[data-disabled]]:bg-color-comp-accordion-filled-container-disabled',
          // Text colors
          'text-color-comp-accordion-filled-on-container-default',
          '[&[data-disabled]]:text-color-comp-accordion-filled-on-container-disabled',
          '[&:not([data-disabled])]:[&>*:first-child]:hover:text-color-comp-accordion-filled-on-container-hover',
          // Subtitle
          '[&_[data-subtitle]]:text-color-comp-accordion-filled-subtext-default',
          '[&_[data-subtitle]]:[&:not([data-disabled])]:hover:text-color-comp-accordion-filled-subtext-hover',
          '[&_[data-subtitle]]:[&[data-disabled]]:text-color-comp-accordion-filled-subtext-disabled',
        ],
        outlined: [
          'first:border-t-2',
          'last:border-b-2',
          'border-x-2',
          // Border colors
          'border-color-comp-accordion-outline-stroke-default',
          'hover:border-color-comp-accordion-outline-stroke-hover',
          'data-[disabled]:border-color-comp-accordion-outline-stroke-disabled',
          // Background colors
          'bg-color-comp-accordion-outline-container-default',
          '[&[data-disabled]]:bg-color-comp-accordion-outline-container-disabled',
          // Text colors
          'text-color-comp-accordion-outline-on-container-default',
          '[&[data-disabled]]:text-color-comp-accordion-outline-on-container-disabled',
          '[&:not([data-disabled])]:[&>*:first-child]:hover:text-color-comp-accordion-outline-on-container-hover',
          // Subtitle
          '[&_[data-subtitle]]:text-color-comp-accordion-outline-subtext-default',
          '[&_[data-subtitle]]:[&:not([data-disabled])]:hover:text-color-comp-accordion-outline-subtext-hover',
          '[&_[data-subtitle]]:[&[data-disabled]]:text-color-comp-accordion-outline-subtext-disabled',
        ],
      },
    },
    defaultVariants: {
      fill: 'filled',
      grouped: false,
    },
  },
);
